// import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Grid } from "@mui/material";
import dayjs from "dayjs";
import { FormikProps } from "formik";
import { forwardRef, useMemo } from "react";
import CustomDatePicker from "@/components/CustomDatePicker";
// import Flex from "@/components/Flex";
import FormSection from "@/components/FormSection";
// import Text from "@/components/Text";
// import { RecurringConfig } from "@/components/app/provider/scheduling/RecurringConfig";
// import {
//   CHART_COLORS,
//   CHART_TYPOGRAPHY,
// } from "@/components/app/provider/patient/chart";
import { GROUP_LABEL, GROUP_SECTION } from "../group-visit-constant";
import { GroupFormValues } from "../group-visit-types";

export type GroupAvailabilitySectionProps = {
  formik: FormikProps<GroupFormValues>;
  disabled?: boolean;
};

/**
 * @author Rajkumar Rathod
 */
const GroupAvailabilitySection = forwardRef<
  HTMLDivElement,
  GroupAvailabilitySectionProps
>(({ formik, disabled }, ref) => {
  const { values, errors, touched, setFieldValue, handleBlur } = formik;
  const today = useMemo(() => dayjs().startOf("day"), []);

  return (
    <FormSection
      variant="plain"
      ref={ref}
      id={GROUP_SECTION.AVAILABILITY}
      title={GROUP_LABEL.availabilitySection}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <CustomDatePicker
            label={GROUP_LABEL.startDate}
            required
            name="startDate"
            minDate={today}
            disabled={disabled}
            value={values.startDate}
            handleBlur={handleBlur}
            onChange={(value) => setFieldValue("startDate", value)}
            error={touched.startDate && (errors.startDate as string)}
          />
        </Grid>

        {/*
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Flex flexDirection="column">
            <FormControlLabel
              name="isRecurring"
              control={<Checkbox />}
              label={
                <Text fontWeight={500}>{GROUP_LABEL.recurringSchedule}</Text>
              }
              checked={values.isRecurring}
              disabled={disabled}
              onChange={(_, checked) => setFieldValue("isRecurring", checked)}
            />
            <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
              {GROUP_HELPER_TEXT.recurringSchedule}
            </Text>
          </Flex>
        </Grid>

        {values.isRecurring && (
          <RecurringConfig formik={formik} required disabled={disabled} />
        )}
        */}
      </Grid>
    </FormSection>
  );
});

GroupAvailabilitySection.displayName = "GroupAvailabilitySection";

export default GroupAvailabilitySection;
